/* eslint-disable object-curly-newline */
import getDefaultState from './get-default-state';

export default {
  setAuthorizationInfos(state, authorization) {
    state.authorization = authorization;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
